export default "__VITE_ASSET__CSIU5zXq__"